import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { iconsFa } from './../../utils/iconsFa';
import { Container, Row, Title } from './styles';
import api from './../../services/api';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { ca } from 'date-fns/locale';

export const SocialMedia = ({ query, company }) => {
  const [socialMedia, setSocialMedia] = useState();
  useEffect(() => {
    async function load() {
      const { label, page_label } = query;

      const socialNetworkUrl =
        label && page_label
          ? `pages/sections/social-network/get/${label}/${page_label}`
          : `pages/sections/social-network/get/${label}`;

      try {
        const { data } = await api.get(socialNetworkUrl);

        // Verificação de segurança para evitar erros quando data.data é undefined
        if (data && data.data) {
          setSocialMedia(data.data);
        } else {
          console.warn('API response data structure is invalid in SocialMedia component:', data);
          setSocialMedia({});
        }
      } catch (error) {
        console.error('Error loading social media data:', error);
        setSocialMedia({});
      }
    }

    let isMoutend = true;

    if (isMoutend && query) {
      load();
    }

    return () => {
      isMoutend = false;
    };
  }, [query]);

  function getUpdatedUrl(url) {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'https://' + url;
    }
    return url;
  }

  return (
    <Container id="socialNetwork" actived={socialMedia?.active}>
      <Title>Conheça nossos canais</Title>
      <Row>
        <a href={company?.url} target="_blank">
          <FontAwesomeIcon icon={faGlobe} color={'#667085'} size="2x" />
        </a>
        {socialMedia?.links?.map((social, index) => (
          <a key={index} href={getUpdatedUrl(social.url)} target="_blank">
            <FontAwesomeIcon
              icon={
                iconsFa.filter(icon => icon.iconName === social.icon)[0]?.icon
              }
              color={'#667085'}
              size="2x"
            />
          </a>
        ))}
      </Row>
    </Container>
  );
};
